(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    function aritualSignupAnalyticsAllowed() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch (_error) {
      return false;
    }
  }

  function recordAritualSignup(eventName, signupLocation, attempts = 0) {
    if (!window.Shopify?.customerPrivacy && attempts < 20) {
      setTimeout(() => recordAritualSignup(eventName, signupLocation, attempts + 1), 250);
      return;
    }
    if (!aritualSignupAnalyticsAllowed() || window.Shopify?.designMode) return;
    window.dataLayer = window.dataLayer || [];
    function sendExistingGoogleEvent() {
      window.dataLayer.push(arguments);
    }
    sendExistingGoogleEvent('event', eventName, {
      send_to: 'G-QD456VGDFE',
      method: 'email',
      signup_location: signupLocation,
      page_location: window.location.origin + window.location.pathname,
    });
  }

  function initializeAritualNewsletterTracking(root = document) {
    root.querySelectorAll('[data-aritual-signup-block]').forEach((block) => {
      if (block.hasAttribute('data-klaviyo-candle-signup')) return;
      if (!block.closest('.shopify-section-group-footer-group, footer')) return;
      if (block.dataset.aritualNewsletterInitialized === 'true') return;
      const form = block.querySelector('form');
      if (!form) return;
      block.dataset.aritualNewsletterInitialized = 'true';
      const pendingKey = 'aritual:analytics:newsletter:pending';
      let pending;
      try {
        pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      } catch (_error) {}
      if (pending?.blockId === block.dataset.aritualSignupBlock) {
        try { sessionStorage.removeItem(pendingKey); } catch (_error) {}
        if (
          Date.now() - pending.createdAt >= 0 &&
          Date.now() - pending.createdAt < 15 * 60 * 1000 &&
          pending.path === window.location.pathname &&
          block.querySelector('[data-aritual-newsletter-success]:not([hidden])')
        ) {
          recordAritualSignup('newsletter_signup_completed', 'footer');
        }
      }
      const successMessage = block.querySelector('[data-aritual-newsletter-success]');
      const errorMessage = block.querySelector('[data-aritual-newsletter-error]');
      const submitButton = form.querySelector('button');
      const nativeSubmit = form.submit.bind(form);
      const inlineSubmission = !window.Shopify?.designMode &&
        !form.dataset.hcaptchaBound && !form.dataset.recaptchaBound &&
        typeof window.Shopify?.captcha?.protect === 'function';
      if (inlineSubmission) {
        form.submit = async () => {
          if (form.dataset.aritualNewsletterSubmitting === 'true') return;
          form.dataset.aritualNewsletterSubmitting = 'true';
          form.setAttribute('aria-busy', 'true');
          if (submitButton) submitButton.disabled = true;
          successMessage.hidden = true;
          errorMessage.hidden = true;
          try {
            const response = await fetch(form.action, {
              method: 'POST',
              credentials: 'same-origin',
              headers: { Accept: 'text/html' },
              body: new URLSearchParams(new FormData(form)),
            });
            const responseUrl = new URL(response.url);
            if (responseUrl.origin !== window.location.origin) throw new Error('Unexpected response origin');
            if (responseUrl.pathname === '/challenge') {
              window.location.assign(responseUrl.href);
              return;
            }
            if (!response.ok) throw new Error('Subscription request failed');
            const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
            const responseBlock = Array.from(responseDocument.querySelectorAll('[data-aritual-signup-block]'))
              .find((item) => item.dataset.aritualSignupBlock === block.dataset.aritualSignupBlock);
            const confirmed = responseBlock?.querySelector('[data-aritual-newsletter-success]:not([hidden])');
            if (!confirmed) throw new Error('Subscription was not confirmed');
            successMessage.hidden = false;
            errorMessage.hidden = true;
            form.reset();
            try { sessionStorage.removeItem(pendingKey); } catch (_error) {}
            recordAritualSignup('newsletter_signup_completed', 'footer');
            successMessage.focus();
          } catch (_error) {
            errorMessage.hidden = false;
            successMessage.hidden = true;
            try { sessionStorage.removeItem(pendingKey); } catch (_storageError) {}
          } finally {
            delete form.dataset.aritualNewsletterSubmitting;
            form.removeAttribute('aria-busy');
            if (submitButton) submitButton.disabled = false;
          }
        };
        window.Shopify.captcha.protect(form);
      }
      form.addEventListener('submit', (event) => {
        if (!form.reportValidity()) return;
        if (inlineSubmission) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (typeof window.Shopify?.captcha?.protect === 'function') {
            window.Shopify.captcha.protect(form, () => form.submit());
          } else {
            nativeSubmit();
          }
        }
        if (!form.reportValidity() || !aritualSignupAnalyticsAllowed() || window.Shopify?.designMode) return;
        try {
          sessionStorage.setItem(pendingKey, JSON.stringify({
            blockId: block.dataset.aritualSignupBlock,
            createdAt: Date.now(),
            path: window.location.pathname,
          }));
        } catch (_error) {}
      }, { capture: true });
    });
  }

  const klaviyoCandleSignupSelector = '[data-klaviyo-candle-signup]';
  const klaviyoCandleStoragePrefix = 'aritual:klaviyo:candle-launch:';

  function setKlaviyoCandleStatus(block, status) {
    const successMessage = block.querySelector('[data-klaviyo-candle-success]');
    const errorMessage = block.querySelector('[data-klaviyo-candle-error]');

    if (successMessage) successMessage.hidden = status !== 'success';
    if (errorMessage) errorMessage.hidden = status !== 'error';
  }

  function initializeKlaviyoCandleSignup(block) {
    if (block.dataset.klaviyoCandleInitialized === 'true') return;

    const form = block.querySelector('form');
    const emailInput = form?.querySelector('input[type="email"]');
    const submitButton = form?.querySelector('button');

    if (!form || !emailInput || !submitButton) return;

    block.dataset.klaviyoCandleInitialized = 'true';

    const storageKey = `${klaviyoCandleStoragePrefix}${block.dataset.klaviyoListId}`;

    try {
      if (localStorage.getItem(storageKey) === 'true') {
        setKlaviyoCandleStatus(block, 'success');
      }
    } catch (_error) {}

    form.addEventListener(
      'submit',
      async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (form.dataset.submitting === 'true' || !form.reportValidity()) return;

        form.dataset.submitting = 'true';
        form.setAttribute('aria-busy', 'true');
        submitButton.disabled = true;
        setKlaviyoCandleStatus(block, 'idle');

        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Ritual candle launch signup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: emailInput.value.trim(),
                    properties: {
                      'Ritual Candle Launch': true,
                      'Signup Source': 'Candle storytelling block',
                    },
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED',
                        },
                      },
                    },
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: block.dataset.klaviyoListId,
                },
              },
            },
          },
        };

        try {
          const response = await fetch(
            `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(
              block.dataset.klaviyoCompanyId
            )}`,
            {
              method: 'POST',
              headers: {
                Accept: 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
                revision: '2026-07-15',
              },
              body: JSON.stringify(payload),
            }
          );

          if (response.status !== 202) throw new Error(`Klaviyo returned ${response.status}`);

          recordAritualSignup('candle_launch_signup_completed', 'homepage_candle');
          form.reset();
          setKlaviyoCandleStatus(block, 'success');

          try {
            localStorage.setItem(storageKey, 'true');
          } catch (_error) {}
        } catch (_error) {
          setKlaviyoCandleStatus(block, 'error');
        } finally {
          delete form.dataset.submitting;
          form.removeAttribute('aria-busy');
          submitButton.disabled = false;
        }
      },
      { capture: true }
    );
  }

  function initializeKlaviyoCandleSignups(root = document) {
    root.querySelectorAll(klaviyoCandleSignupSelector).forEach(initializeKlaviyoCandleSignup);
    initializeAritualNewsletterTracking(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeKlaviyoCandleSignups(), { once: true });
  } else {
    initializeKlaviyoCandleSignups();
  }

  document.addEventListener('shopify:section:load', (event) => initializeKlaviyoCandleSignups(event.target));
  } catch(e) { console.error(e); }
})();

})();
